import type { ContactUsConfig } from './types'
import { commonTexts } from './common'

/**
 * Pearla 品牌 Contact Us 页面配置
 */
export const contactUsConfig: ContactUsConfig = {
  texts: commonTexts,
  colors: {
    bgPrimary: '#ffffff', // 主背景
    bgTertiary: '#F3F5FA', // 三级背景
    textPrimary: '#32353A', // 主要文本
    textTertiary: '#9296A0', // 三级文本
    textPlaceholder: '#c8c9cc', // 占位符文本
    accentRed: '#FC5549', // 红色强调
    primaryColor: '#AB75FB', // 品牌主色
    whiteColor: '#FFFFFF', // 白色
  },
}
